<template>
  <div class="columns m-0 p-0" style="height: 100%">
    <div class="column m-0 p-0 ml-2 mr-1 is-flex is-flex-direction-column">
      <div class="mt-auto mb-auto">
        <live-tag :name="firstStageName" :tasks="lyraOrYoloTasks" :property-set="lyraOrYoloSet" v-if="lyraOrYoloSet"></live-tag>
        <live-tag style="margin-top: 2px !important;" name="Seacliff" :tasks="seacliffTasks" :property-set="seacliffSet" v-if="seacliffSet"></live-tag>
        <live-tag style="margin-top: 2px !important;" name="Traffic Light" :tasks="trafficLightTasks" :property-set="trafficLightSet" v-if="trafficLightSet"></live-tag>
        <live-tag style="margin-top: 2px !important;" name="Motorcycle" :tasks="motorcycleTasks" :property-set="motorcycleSet" v-if="motorcycleSet"></live-tag>
      </div>
    </div>
    <b-icon icon="arrow-right-thick" class="mt-auto mb-auto"></b-icon>
    <div class="column m-0 p-0 ml-1 mr-1 is-flex is-flex-direction-column">
      <div class="mt-auto mb-auto">
        <live-tag :name="velaName" :tasks="velaTasks" :property-set="velaSet" v-if="lyraOrYoloSet"></live-tag>
        <live-tag style="margin-top: 2px !important;" :tasks="seacliffAgenAiTasks" name="AI Video Analysis" :property-set="seacliffSet" v-if="seacliffSet"></live-tag>
        <live-tag style="margin-top: 2px !important;" status="RUNNING" name="Available in DB" data="16/126" :hidden="true" v-if="trafficLightSet"></live-tag>
        <live-tag style="margin-top: 2px !important;" status="RUNNING" name="Available in DB" data="16/126" :hidden="true" v-if="motorcycleSet"></live-tag>
      </div>
    </div>
    <b-icon icon="arrow-right-thick" class="mt-auto mb-auto"></b-icon>
    <div class="column m-0 p-0 ml-1 mr-1 is-flex is-flex-direction-column">
      <div class="mt-auto mb-auto">
        <live-tag v-if="eventProcessingSet && lyraOrYoloSet" name="Event processing" :tasks="eventsTasks" :property-set="eventProcessingSet"></live-tag>
        <live-tag v-else-if="dtpValidationChartsSet && lyraOrYoloSet" name="Validation Charts" :property-set="eventProcessingSet"></live-tag>
        <live-tag style="margin-top: 2px !important;" status="RUNNING" name="Vela" data="16/126" :hidden="true" v-if="seacliffSet"></live-tag>
        <live-tag style="margin-top: 2px !important;" status="RUNNING" name="Available in DB" data="16/126" :hidden="true" v-if="trafficLightSet"></live-tag>
        <live-tag style="margin-top: 2px !important;" status="RUNNING" name="Available in DB" data="16/126" :hidden="true" v-if="motorcycleSet"></live-tag>
      </div>
    </div>
    <div class="column is-flex m-0 p-0 mr-1" style="max-width: 80px; max-height: 72px">
    <b-tooltip v-if="refreshing"
               class="ml-auto mr-0 mt-auto mb-auto" label="Please Wait..." :delay="1000" type="is-dark"
               position="is-left">
      <div v-if="refreshing" class="my-loader mt-1 mb-1"></div>
    </b-tooltip>
      <div v-else-if="!refreshing" class="ml-2 is-flex">
        <b-tooltip
                   class="ml-auto mr-1 mt-auto mb-auto" label="Please Wait..." :delay="1000" type="is-dark"
                   position="is-left">
          <b-icon
              icon="progress-clock"
              class="clickable" size="is-medium"></b-icon>

          <b-progress size="is-small" :value="progressValue"></b-progress>
        </b-tooltip>
        <b-tooltip
                   class="ml-1 mr-0 mt-auto mb-auto" label="Trigger back processing" :delay="1000" type="is-dark"
                   position="is-left">
          <b-icon
              icon="play-box"
              class="clickable" size="is-medium"
              style="color: rgba(30,43,87,0.8)"
              @click.native.stop="onTriggerBackProcessing"
          ></b-icon>
        </b-tooltip>
      </div>

    </div>
  </div>
</template>

<script>
import LiveTag from "@/modules/data-processing-tmc-module/components/live-tag/live-tag.vue";

export default {
  name: "live-processing-info",
  components: {LiveTag},
  props: {
    liveProcessingDeviceData: {
      type: Object
    },
    deviceData:{
      type: Object
    },
    refreshing: {
      type: Boolean
    }
  },
  data() {
    return {
      progressValue: 0,
    }
  },
  methods:{
    setProgress(progress) {
      this.progressValue = progress
    },
    onTriggerBackProcessing(){
      this.$emit('onTriggerBackProcessing')
    }
  },
  computed:{
    lyraOrYoloTasks(){
      if(this.liveProcessingDeviceData && this.liveProcessingDeviceData.lyraTasks){
        console.log('On get lyra tasks: ', this.liveProcessingDeviceData.lyraTasks)
        return this.liveProcessingDeviceData.lyraTasks
      }
      if(this.liveProcessingDeviceData && this.liveProcessingDeviceData.yoloTasks){
        console.log('On get lyra tasks: ', this.liveProcessingDeviceData.yoloTasks)
        return this.liveProcessingDeviceData.yoloTasks
      }
      return null
    },
    velaTasks(){
      if(this.liveProcessingDeviceData && this.liveProcessingDeviceData.velaWithLyraTasks){
        console.log('On get vela tasks: ', this.liveProcessingDeviceData.velaWithLyraTasks)
        return this.liveProcessingDeviceData.velaWithLyraTasks
      }
      if(this.liveProcessingDeviceData && this.liveProcessingDeviceData.velaWithYoloTasks){
        console.log('On get vela tasks: ', this.liveProcessingDeviceData.velaWithYoloTasks)
        return this.liveProcessingDeviceData.velaWithYoloTasks
      }
      return null
    },
    seacliffTasks(){
      if(this.liveProcessingDeviceData && this.liveProcessingDeviceData.seacliffTasks){
        console.log('On get seacliff tasks: ', this.liveProcessingDeviceData.seacliffTasks)
        return this.liveProcessingDeviceData.seacliffTasks
      }
      return null
    },
    seacliffAgenAiTasks(){
      if(this.liveProcessingDeviceData && this.liveProcessingDeviceData.seacliffAgenAiTasks){
        console.log('On get seacliff agen ai tasks: ', this.liveProcessingDeviceData.seacliffAgenAiTasks)
        return this.liveProcessingDeviceData.seacliffAgenAiTasks
      }
      return null
    },
    eventsTasks(){
      if(this.liveProcessingDeviceData && this.liveProcessingDeviceData.processingEventsTasks){
        return this.liveProcessingDeviceData.processingEventsTasks
      }
      return null
    },
    trafficLightTasks(){
      if(this.liveProcessingDeviceData && this.liveProcessingDeviceData.trafficLightTasks){
        console.log('On get traffic light tasks: ', this.liveProcessingDeviceData.trafficLightTasks)
        return this.liveProcessingDeviceData.trafficLightTasks
      }
      return null
    },
    motorcycleTasks(){
      if(this.liveProcessingDeviceData && this.liveProcessingDeviceData.motorcycleTasks){
        return this.liveProcessingDeviceData.motorcycleTasks
      }
      return null
    },
    lyraOrYoloSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.ai && (this.deviceData.dataRequired.ai.includes('lyra') || this.deviceData.dataRequired.ai.includes('yolo'))
    },
    seacliffSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.ai && this.deviceData.dataRequired.ai.includes('seacliff')
    },
    trafficLightSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.ai && this.deviceData.dataRequired.ai.includes('traffic-light')
    },
    velaSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.data && (this.deviceData.dataRequired.data.includes('vela_with_yolo') || this.deviceData.dataRequired.data.includes('vela_with_lyra'))
    },
    eventProcessingSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.events && this.deviceData.dataRequired.events.includes('near_miss')
    },
    dtpValidationChartsSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.events && this.deviceData.dataRequired.events.includes('dtp')
    },
    motorcycleSet(){
      return this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.ai && this.deviceData.dataRequired.ai.includes('motorcycle')
    },
    velaName(){
      let name
      if(this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.data){
        if(this.deviceData.dataRequired.data.includes('vela_with_lyra')){
          name = 'Vela With Lyra'
        }
        if(this.deviceData.dataRequired.data.includes('vela_with_yolo')){
          if(name){
            name += '/Vela With Yolo'
          } else{
            name = 'Vela With Yolo'
          }
        }
      }
      return name
    },
    firstStageName(){
      let name
      if(this.deviceData && this.deviceData.dataRequired && this.deviceData.dataRequired.ai){
        if(this.deviceData.dataRequired.ai.includes('lyra')){
          name = 'Lyra'
        }
        if(this.deviceData.dataRequired.ai.includes('yolo')){
          if(name){
            name += '/Yolo'
          } else{
            name = 'Yolo'
          }
        }
      }
      return name
    }
  }

}
</script>

<style scoped>
.my-loader {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #1cab80;
  border-bottom: 4px solid #1cab80;
  width: 30px;
  height: 30px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>